/**
 * 创建人：D
 * 创建时间：2019-07-12
 * 描述：获取字典表项
 * 更新记录:
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SwHttpClientService } from '../sw-http-client.service';
import { SwJwtService } from '../sw-jwt.service';


/**
 * 获取字典项 ，写入缓存完成字典初始化
 */
@Injectable()
export class DictionaryService {

  /**
   * @ignore
   */
  constructor(
    private jwt: SwJwtService,  //本地缓存服务
    private http: SwHttpClientService
  ) {
  }

  /**
   * 返回字典项,下拉框,下拉树  dictionaryId or dictionaryName
   * @param key 传入的字典key
   */
  getDictionaryNameByValue(value: string) {
    //获取缓存中的字典数据
    let dictionary = JSON.parse(this.jwt.getToken("dictionary"));
    //获取当前语言
    let currLanguage = this.jwt.getToken('language')
    // let DicList = [];
    if (dictionary) {
      //通过key 去查找数据;过滤掉禁用数据
      let dic = dictionary.filter(x => x.dictionaryValue == value);
      let text = ''
      if (currLanguage == 'en-US' && dic[0].dictionaryNameEn) {
        text = dic[0].dictionaryNameEn
      } else {
        text = dic[0].dictionaryName
      }
      return text;

    } else {
      return "";
    }
  }

  /**
   * 返回字典项,下拉框,下拉树  dictionaryId or dictionaryName
   * @param key 传入的字典key
   */
  getDictionaryIdOrName(key: string) {
    //获取缓存中的字典数据
    let dictionary = JSON.parse(this.jwt.getToken("dictionary"));
    //获取当前语言
    let currLanguage = this.jwt.getToken('language')
    let DicList = [];
    if (dictionary) {
      //通过key 去查找数据;过滤掉禁用数据
      let dic = dictionary.filter(x => x.dictionaryCode == key);
      dic.forEach(e => {
        let text = ''
        if (currLanguage == 'en-US' && e.dictionaryNameEn) {
          text = e.dictionaryNameEn
        } else {
          text = e.dictionaryName
        }
        DicList.push({ "id": e.dictionaryId, "text": text })
      });
      return DicList;

    } else {
      return [];
    }
  }


  /**
   *  获取数据 dictionaryValue or  dictionaryName
   * @param key 字典的key值（对应dictionary_code）
   */
  getDictionaryValueOrName(key: string) {
    //获取缓存中的字典数据
    let dictionary = JSON.parse(this.jwt.getToken("dictionary"));
    //获取当前语言
    let currLanguage = this.jwt.getToken('language')
    let DicList = [];
    if (dictionary) {
      //通过key 去查找数据;过滤掉禁用数据
      let dic = dictionary.filter(x => x.dictionaryCode == key && x.status);
      //按照 sort 升序重新排序
      this.sort(dic)
      dic.forEach(e => {
        let text = ''
        if (currLanguage == 'en-US' && e.dictionaryNameEn) {
          text = e.dictionaryNameEn
        } else {
          text = e.dictionaryName
        }
        DicList.push({ "id": e.dictionaryValue, "text": text })
      });
      return DicList;
    } else {
      return [];
    }
  }

  //对数组中的时间进行从小到大进行排序
  sort(arr) {
    arr.sort(function (a, b) {
      return a.sort - b.sort
    })
  }

  /**
   * 字典的值 自定义值
   * @param key   【输入参数】 字典的关键字（dictionary_code）
   * @param id    【输出参数】 下拉项值
   * @param text  【输出参数】 下拉显示名
   */
  getDictionary(key: string, id: string, text: string) {
    //获取缓存中的字典数据
    let dictionary = JSON.parse(this.jwt.getToken("dictionary"));
    let DicList = [];
    if (dictionary) {
      //通过key 去查找数据;过滤掉禁用数据
      let dic = dictionary.filter(x => x.dictionaryCode == key && x.status);
      dic.forEach(e => {
        DicList.push({ "id": e[id], "text": e[text], "key": e.dictionaryCode })
      });
      return DicList;

    } else {
      return [];
    }
  }



  /**
   * 字典的树形数据结构 自定义主键
   * @param key 字典的key值
   * @param id 显示的id值
   * @param text 显示的id值
   * @param pid 显示的pid值
   */
  getDictionaryTree(key: string, id: string, text: string, pid: string, value: string = 'id') {
    //获取缓存中的字典数据
    let dictionary = JSON.parse(this.jwt.getToken("dictionary"));
    let DicList = [];
    if (dictionary) {
      //通过key 去查找数据;过滤掉禁用数据
      let dic = dictionary.filter(x => x.dictionaryCode == key);

      dic.forEach(e => {
        DicList.push({ "id": e[id], "text": e[text], "pid": e[pid], "value": e[value] })
        this.treeDic(DicList, e, dictionary, id, text, pid, value);
      });
      return DicList;

    } else {
      return [];
    }
  }

  /**
   * 通过value的值获取下级数据
   * @param Value  value
   */
  getDictionaryValueAndNameByParentValue(Value: string) {
    let dictionary = JSON.parse(this.jwt.getToken("dictionary"));
    //获取当前语言
    let currLanguage = this.jwt.getToken('language')
    let DicList = [];
    if (dictionary) {
      let dic = dictionary.filter(x => x.dictionaryValue == Value);
      if (dic.length > 0) {
        dic = dictionary.filter(x => x.parentId == dic[0].dictionaryId);
        dic.forEach(e => {
          let text = ''
          if (currLanguage == 'en-US' && e.dictionaryNameEn) {
            text = e.dictionaryNameEn
          } else {
            text = e.dictionaryName
          }
          DicList.push({ "id": e.dictionaryValue, "text": text, "key": e.dictionaryCode })
        });
        return DicList;
      } else
        return null;

    } else
      return null;
  }


  /**
   * 递归树形机构数据
   * @param DicList 保存数据
   * @param dicModel //查询当前数据
   * @param dictionary  //所有的树形数据
   * @ignore
   */
  treeDic(DicList: any, dicModel: any, dictionary: any, id: string, text: string, pid: string, value: string) {
    let dic = dictionary.filter(x => x.parentId == dicModel.id);
    dic.forEach(e => {
      DicList.push({ "id": e[id], "text": e[text], "pid": e[pid], "value": e[value] })
      this.treeDic(DicList, e, dictionary, id, text, pid, value);
    });
  }
  /**
  * 返回字典
  * @param value 传入的字典值
  */
  getDictionaryValue(value: string) {
    //获取缓存中的字典数据
    let dictionary = JSON.parse(this.jwt.getToken("dictionary"));
    // let DicList = [];
    if (dictionary) {
      //通过key 去查找数据;过滤掉禁用数据
      let dic = dictionary.filter(x => x.dictionaryValue == value);
      return dic[0];

    } else {
      return "";
    }
  }

  //http方式请求字典值，用于特殊字典项
  getDictionaryValueForPost(key: string) {
    let url = environment.seekerWebAPI;
    let param = {
      entity: { "dictionaryCode": key },
      param: { 'pageSize': 0 }
    }
    return this.http.Post(url + "dictionary/queryPageList", param)
  }

}

